import { Constants } from "modules/root/models/constants";

/**
 * Состояние раздела на вкладке «Проект»:
 * missing — нет ни исходного файла, ни результата: проект не перевести в Завершение/Завершено;
 * unsigned — файлы есть, но результат подписан не всеми;
 * signed — последние версии всех результатов подписаны всеми подписантами.
 */
export type UnitStatus = "missing" | "unsigned" | "signed";

type TaskFiles = { files: ReadonlyArray<any> } | undefined;

export const unitStatus = (contentTask: TaskFiles): UnitStatus => {
    const files = contentTask?.files ?? [];
    const results = files.filter((f) => f.type === Constants.orderFileTypeContentTaskResult);
    const sources = files.filter((f) => f.type === Constants.orderFileTypeContentTaskSource);

    if (!results.length && !sources.length) {
        return "missing";
    }

    if (!results.length) {
        return "unsigned";
    }

    // у каждого файла смотрим только последнюю версию
    const latest = new Map<string, any>();
    results.forEach((file) => {
        const current = latest.get(file.name);
        if (!current || current.version < file.version) {
            latest.set(file.name, file);
        }
    });

    const signed = Array.from(latest.values()).every(
        (file) => file.signatures?.length > 0 && file.signatures.every((s: any) => s.signed === true)
    );

    return signed ? "signed" : "unsigned";
};

export const unitStatusTitle: Record<UnitStatus, string> = {
    missing: "Не загружен результат работ: проект не перевести в Завершение",
    unsigned: "Результат работ подписан не всеми",
    signed: "Результат работ подписан",
};
